// extracted by mini-css-extract-plugin
export default {"Cabinet":"AffichageChoixCabinet_Cabinet__7fBsj","ListeCabinets":"AffichageChoixCabinet_ListeCabinets__GyysL"};